<div class="text-meta">
  <div class="row">
    <app-text [formGroup]="$safeNavigationMigration(model()?.meta?.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.pattern)" [meta]="metaPattern"></app-text>
  </div>
  <div class="row">
    <app-number [formGroup]="$safeNavigationMigration(model()?.meta?.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.maxLength)" [meta]="metaMaxLength"></app-number>
  </div>
</div>
